export function loginDialogToMall(
  showmsg,
  permissionArray,
  _this,
  confirmButtonText = "在线商城",
  cancelButtonText = "关闭"
) {
  return _this.$dialog
    .confirm({
      title: "提示",
      message: showmsg,
      confirmButtonText,
      cancelButtonText,
    })
    .then(() => {
      if (permissionArray.includes("900001")) {
        _this.$router.push("onlineMall");
      }
    })
    .catch(() => {
      _this.$router.push("/newFiles");
      // 取消
    });
}

export function errDialog(
  showmsg,
  _this,
  confirmButtonText = "是",
  cancelButtonText = "否",
  cb,
  errfunc
) {
  return _this.$dialog
    .confirm({
      title: "提示",
      message: showmsg,
      confirmButtonText,
      cancelButtonText,
    })
    .then(() => {
      if (typeof cb == "function") {
        cb();
      }
    })
    .catch((err) => {
      if (typeof errfunc == "function") {
        errfunc();
      }
      // 取消
      console.log("err", err);
    });
}

export function commonDialog(showmsg, _this, confirmButtonText = "确认", cb) {
  return _this.$dialog
    .alert({
      message: showmsg,
      confirmButtonText: confirmButtonText,
      theme: "round-button",
    })
    .then(() => {
      console.log(Object.prototype.toString.call(cb));
      if (Object.prototype.toString.call(cb) === "[object Function]") {
        cb();
      }
    })
    .catch((err) => {
      console.log("err", err);
    });
}

export function commonNotify(message, _this, duration = 3) {
  return _this.$notify({
    message: message,
    duration: duration * 1000,
    type: "success",
  });
}

export function warningNotify(message, _this, duration = 3) {
  return _this.$notify({
    message: message,
    duration: duration * 1000,
    type: "warning",
  });
}

export function commonToast(message, _this, duration = 3000) {
  return _this.$toast({
    duration,
    message,
  });
}
